<template>
  <ol
    class="breadcrumb mb-0"
    data-testid="breadcrumb"
  >
    <template v-for="(route, index) in routes">
      <li
        :key="route.path"
        class="breadcrumb-item"
        :class="{ active: false }"
        data-testid="breadcrumb-item"
      >
        <router-link
          v-if="index < routes.length - 1"
          :class="{ 'breadcrumb-item': true }"
          data-testid="breadcrumb-link"
          :to="route"
        >
          <span
            v-b-tooltip
            :data-testid="`header-breadcrumb-${index}-item`"
            :style="route.meta.title === null ? 'font-weight:700' : 'font-weight:400'"
            :title="routeName(route)"
          >
            {{ truncate(routeName(route), 50) }}
          </span>
        </router-link>
        <span
          v-else
          v-b-tooltip
          :data-testid="`header-breadcrumb-${index}-item`"
          :style="route.meta.title === null ? 'font-weight:700' : 'font-weight:400'"
          :title="routeName(route)"
        >
          {{ truncate(routeName(route), 50) }}
        </span>
      </li>
    </template>
  </ol>
</template>

<script>
import { mapGetters } from 'vuex'
import { t } from '@/I18n'
import { truncate } from '@/helpers/Text.helpers'
import { SECURITY_BASE_ROUTE_NAMES } from '@/contexts/security-base/SecurityBase.constants'

export default {
  name: 'PageHeaderTitle',
  computed: {
    ...mapGetters({
      main_titles: 'main_titles',
    }),
    routes: function () {
      return this.$route.matched
        .filter((route, i, source) => {
          if (i > 0) {
            const previousRoute = source[i - 1]

            if (route.meta.hide_in_breadcrumb || (previousRoute.meta.multi && i === source.length - 1)) {
              return false
            }
          }

          return route.meta.dummy !== true || route.meta.multi === true
        })
        .map((route) => {
          const name = this.$router.resolve({ path: route.path }).route.name

          const query = {}
          const policyId = this.$route.query?.policyId

          // Pass down query param "policyId" for security base route
          if (
            policyId &&
            (name === SECURITY_BASE_ROUTE_NAMES.PERIMETERS || name === SECURITY_BASE_ROUTE_NAMES.MEASURES)
          ) {
            query.policyId = policyId
          }

          return {
            ...route,
            name,
            query,
          }
        })
        .filter((route) => !!this.routeName(route))
    },
  },
  methods: {
    truncate,
    routeName(route) {
      if (route.name === 'dashboard_share') {
        return this.$store.getters.lang === 'fr' ? 'Tableau de bord partagé' : 'Shared dashboard'
      }

      if (route.meta.i18nAltTitle) {
        return t(route.meta.i18nAltTitle)
      }

      if (route.meta.i18nTitle) {
        return t(route.meta.i18nTitle)
      }

      if (route.meta.alt_title) {
        return this._(route.meta.alt_title)
      }

      if (route.meta.title) {
        return this._(route.meta.title)
      }

      if (route.name in this.main_titles) {
        return this.main_titles[route.name]
      }

      this.$log.debug('Cannot find title')
    },
  },
}
</script>

<style scoped>
.breadcrumb-item .active {
  cursor: default;
}
</style>
